module.exports = __webpack_public_path__ + "img/more_off.7bcf22ef.svg";